import { Outlet } from "react-router-dom";

import { useLocation } from "react-router-dom";

import { SiteHeader } from "@/components/layout/SiteHeader";
import { SiteFooter } from "@/components/layout/SiteFooter";

export function SiteLayout() {
  const { pathname } = useLocation();
  const isMysticLanding = pathname === "/numeroloji" || pathname.startsWith("/numeroloji/");

  if (isMysticLanding) {
    return (
      <div className="min-h-dvh bg-[#f7f4ff] text-slate-900 dark:bg-[#0a060f] dark:text-slate-200">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-background">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-hero-glow" />
      <div className="pointer-events-none fixed inset-0 -z-10 bg-grid-fade opacity-[0.35] [background-size:22px_22px]" />
      <SiteHeader />
      <main className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
